<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4 col-sm-5 ">
        <h3 class="mb-4 text-md-left">Our goal is to give you the stock recommendations that beat the market in the long term.</h3>
        <p>Exceptional performance of few of our recommended stocks.
        </p>
        <div class="container">
          <div class="row px-0">
            <div
              class="col-md-6 col-sm-6 col-xs-6 pl-0"
              v-for="stock in stockData"
              :key="stock.name"
            >
              <div
                :class="currentStock.name === stock.name ? 'active elevation-9 stock_card': 'elevation-1 stock_card'"
                @click="changeCurrentStock(stock)"
              >
                <h4 class="mb-0">
                  <span>
                    {{ stock.name }}
                  </span>
                </h4>
                <p class="change"><i class="fas fa-arrow-up mr-2" aria-hidden="true"></i> {{ getPercentageChange(stock.data)}} %</i></p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="container">
            <div class="row pl-0" v-for="stock in stockData" :key="stock.name">
              <div :class="currentStock.name === stock.name ? 'active elevation-9 stock_card mb-3': 'elevation-1 stock_card mb-3'" @click="changeCurrentStock(stock)">
                <h4 class="pull-left">
                  <span>
                    {{ stock.name }}
                  </span>
                </h4>
                <p class="change pull-right"><i class="fas fa-arrow-up mr-2"></i> {{ getPercentageChange(stock.data)}} %</i></p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="col-md-7 col-md-offset-1 col-sm-7">
        <p class="stock_name">{{ currentStock.name }}</p>
        <canvas id="myChart"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
  import Chart from "chart.js";
  import stockData from "../util/stock-pricing.json";

  export default {
    name: "HomeGraph",
    computed: {
      stockData() {
        return stockData;
      }
    },
    data: () => {
      return {
        currentStock: stockData[0],
        chart: null
      };
    },
    mounted() {
      this.reRenderChart();
    },
    methods: {
      getPercentageChange(data) {
        const last = data[data.length - 1].High;
        const first = data[0].High;

        return Math.round(((last - first) / first) * 100);
      },
      changeCurrentStock(stock) {
        this.currentStock = stock;
        this.reRenderChart();
      },
      reRenderChart() {
        if (this.myChart) {
          this.myChart.destroy();
        }
        var ctx = document.getElementById("myChart").getContext("2d");

        var gradient = ctx.createLinearGradient(0, 0, 400, 0);
        gradient.addColorStop(0, "rgb(239, 43, 43)");
        gradient.addColorStop(1, "rgb(49, 204, 154)");

        var gradient2 = ctx.createLinearGradient(0, 0, 400, 0);
        gradient2.addColorStop(0, "rgba(239, 43, 43,0.3)");
        gradient2.addColorStop(1, "rgba(49, 204, 154,0.3)");

        this.myChart = new Chart(ctx, {
          type: "line",
          responsive: true,
          data: {
            borderWidth: 3,
            labels: this.currentStock.data.map(stock => {
              const dateArr = new Date(stock.Date).toDateString().split(" ");
              return `${dateArr[1]} ${dateArr[3]}`;
            }),
            datasets: [
              {
                data: this.currentStock.data.map(stock => stock.High),
                borderWidth: 2.5,
                borderColor: gradient,
                backgroundColor: gradient2
              }
            ],
            spanGaps: true
          },
          options: {
            aspectRatio: 1.2,
            responsive: true,
            maintainAspectRatio: true,
            legend: {
              display: false
            },
            elements: {
              point: {
                radius: 0
              }
            },
            scales: {
              xAxes: [
                {
                  gridLines: {
                    color: "rgba(0, 0, 0, 0.0)"
                  }
                }
              ],
              yAxes: [
                {
                  gridLines: {
                    color: "rgba(0, 0, 0, 0.1)"
                  }
                }
              ]
            }
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  h3 {
    font-size: 28px;
    font-weight: 500;
    line-height: 32px;
  }
  .stock_name {
    text-align: center;
    color: #696969;
  }
  .stock_card {
    cursor: pointer;
    h4 {
      font-size: 19px;
      font-weight: 400;
      line-height: 26px;
      padding: 10px;
      padding-bottom: 13px;
      span {
        border-bottom: 2px solid #31cc9a;
      }
    }
    min-height: 130px;
    .change {
      font-size: 28px;
      padding: 10px;
      color: #31cc9a;
      font-weight: 700;
    }
    i {
      color: #31cc9a;
    }
  }
  .active {
    h4 {
      span {
        font-weight: 700;
        border-bottom: 2px solid #fff;
      }
    }
    background: rgba(49, 204, 153, 0.8);
    background: -webkit-linear-gradient(
      to right,
      #31cc9a,
      #7cf8d1
    ); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(
      to right,
      #31cc9a,
      #7cf8d1
    ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

    color: #fff;
    .change {
      color: #fff;
    }
    i {
      color: #fff;
    }
    // box-shadow: 0px 5px 6px -3px rgba(49, 204, 153, 0.3), 0px 9px 12px 1px rgba(49, 204, 153, 0.3),
    //   0px 3px 16px 2px rgba(49, 204, 153, 0.2) !important;
  }
  /*==========  Mobile First Method  ==========*/

  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
  }

  /*==========  Non-Mobile First Method  ==========*/

  /* Large Devices, Wide Screens */
  @media only screen and (max-width: 1200px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width: 320px) {
  }

  @media screen and (max-width: 1024px) {
    h3 {
      font-size: 20px;
      font-weight: 500;
      line-height: 25px;
      margin-bottom: 15px !important;
    }
    .stock_card {
      cursor: pointer;
      h4 {
        font-size: 13px;
        font-weight: 400;
        line-height: 20px;
        padding: 10px;
        span {
          border-bottom: 2px solid #31cc9a;
        }
      }
      min-height: 100px;
      .change {
        font-size: 22px;
        padding: 5px;
        color: #31cc9a;
        font-weight: 700;
      }
      i {
        color: #31cc9a;
      }
    }
    .active {
      h4 {
        span {
          font-weight: 700;
          border-bottom: 2px solid #fff;
        }
      }
      .change {
        color: #fff;
      }
      i {
        color: #fff;
      }
    }
  }
  @media only screen and (max-width: 768px) {
    h3 {
      font-size: 20px;
      font-weight: 500;
      line-height: 25px;
      margin-bottom: 5px !important;
    }
    p {
      margin-bottom: 0px;
    }
    .stock_card {
      cursor: pointer;
      h4 {
        font-size: 13px;
        font-weight: 400;
        line-height: 20px;
        padding: 10px;
        span {
          border-bottom: 2px solid #31cc9a;
        }
      }
      min-height: 90px;
      .change {
        font-size: 22px;
        padding: 5px;
        color: #31cc9a;
        font-weight: 700;
      }
      i {
        color: #31cc9a;
      }
    }
    .active {
      h4 {
        span {
          font-weight: 700;
          border-bottom: 2px solid #fff;
        }
      }
      .change {
        color: #fff;
      }
      i {
        color: #fff;
      }
    }
  }
  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 480px) {
    h3 {
      text-align: center;
    }
    p {
      text-align: center;
    }
  }
  @media only screen and (max-width: 320px) {
    h3 {
      text-align: center;
    }
    p {
      text-align: center;
    }
    .stock_card .change {
      font-size: 15px;
      padding: 5px;
      color: #31cc9a;
      font-weight: 700;
    }
    .stock_card h4 {
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      padding: 10px;
    }
    .active {
      h4 {
        span {
          font-weight: 700;
          border-bottom: 2px solid #fff;
        }
      }
      .change {
        color: #fff;
      }
      i {
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeGraph.vue